function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImport = function SvgImport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 44l0 3.5c0 5.8 4.7 10.5 10.5 10.5l35 0c5.8 0 10.5-4.7 10.5-10.5l0-3.5m-14-14l-14 14m0 0l-14-14m14 14l0-42",
    style: {
      fill: "none"
    }
  }));
};
export default SvgImport;